// extracted by mini-css-extract-plugin
module.exports = {"container":"at","header":"au","title":"av","backButton":"aw","doneButton":"ax","buttonTextStyle":"ay","list":"az","watchlistCheckbox":"aA","loadingContainer":"aB","error":"aC"};